class SocialEngagementService {
  constructor() {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
      
      // Detect production - explicit check for rainbow-sails.shop domain
      // If not localhost and not 127.0.0.1, assume production
      const isProduction = hostname.includes('rainbow-sails.shop') || 
                          (!isLocalhost && hostname !== '127.0.0.1' && hostname !== '0.0.0.0');
      
      // Use localhost:4000 for local dev, or the configured API URL
      // If REACT_APP_API_URL includes /api/v1, use it as-is, otherwise add it
      const envUrl = process.env.REACT_APP_API_URL;
      if (envUrl) {
        this.baseUrl = envUrl.includes('/api/v1') ? envUrl.replace('/api/v1', '') : envUrl;
      } else {
        // Production: use api.rainbow-sails.shop, Development: use localhost:4000
        this.baseUrl = isProduction ? 'https://api.rainbow-sails.shop' : 'http://localhost:4000';
      }
      
      // Debug logging
      console.log('[SOCIAL-ENGAGEMENT] Service initialized:', {
        hostname,
        isLocalhost,
        isProduction,
        baseUrl: this.baseUrl
      });
    } else {
      const envUrl = process.env.REACT_APP_API_URL;
      if (envUrl) {
        this.baseUrl = envUrl.includes('/api/v1') ? envUrl.replace('/api/v1', '') : envUrl;
      } else {
        // Server-side: default to production API
        this.baseUrl = 'https://api.rainbow-sails.shop';
      }
    }
  }

  get apiRoot() {
    // Return /api/v1/social (not /api/social) to match backend routes
    return `${this.baseUrl}/api/v1/social`;
  }

  async getEngagement(contentId) {
    const response = await fetch(`${this.apiRoot}/${encodeURIComponent(contentId)}/engagement`, {
      credentials: 'include'
    });

    if (response.status === 404) {
      return {
        success: true,
        contentId,
        likes: 0,
        likedBy: [],
        comments: []
      };
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch engagement for ${contentId}`);
    }
    return response.json();
  }

  async likeContent(contentId, like = true, user) {
    if (!user || !user.id) {
      throw new Error('User authentication required to like content');
    }

    const response = await fetch(`${this.apiRoot}/${encodeURIComponent(contentId)}/like`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        like,
        userId: user.id,
        userName: [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'Zee Fan'
      })
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `Failed to update like for ${contentId}`);
    }
    return response.json();
  }

  async addComment(contentId, comment, user) {
    if (!user || !user.id) {
      throw new Error('User authentication required to comment');
    }

    const response = await fetch(`${this.apiRoot}/${encodeURIComponent(contentId)}/comments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        ...comment,
        userId: user.id,
        name: comment.name || [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || 'Zee Fan'
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || `Failed to add comment for ${contentId}`);
    }

    return response.json();
  }
}

const socialEngagementService = new SocialEngagementService();
export default socialEngagementService;

